import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["url"]

  submit(event) {
    event.preventDefault()
    let url = this.urlTarget.value.trim()
    
    if (url === '') {
      return
    }

    if (url.startsWith('www.')) {
      url = 'https://' + url
    } else if (!url.startsWith('http://') && !url.startsWith('https://')) {
      url = 'https://' + url
    }
    url = url + '?rt=cmlzZS11cC1jb250ZW50'
    window.open(url, '_blank')
  }
}